import { EntityApiService } from '@dfl/react-security';
import { ISpecialOffer } from 'modules/sales-offer/special-offer/interfaces';

class SpecialOfferService extends EntityApiService<ISpecialOffer> {}

export default new SpecialOfferService('/ms-sales/api/special-offers');
